import {
  ANDROID_OBESITY_STORE_PAGE_URL,
  IOS_OBESITY_STORE_PAGE_URL,
} from "@/constants";
import { obesitySteps } from "../onboarding/obesitySteps";
import { disqualificationSteps } from "../onboarding/disqualificationSteps";
import { landingPageSteps } from "../onboarding/landingPageSteps";
import { FlowConfig } from "./types";
import ObesityRecommendationContent from "./obesity/ObesityRecommendationContent";

export const obesityFlow: FlowConfig = {
  id: "obesity",
  displayName: "Viktnedgång",
  treatmentArea: "OBESITY",
  landingPath: "/",
  entryStepId: "q5",
  pageTitle: "Blodtrycksdoktorn - Modern behandling mot övervikt",
  landing: {
    headline: "Medicinsk viktbehandling med kontinuerligt expertstöd",
    bulletPoints: [
      "Moderna läkemedel och stöd för hållbara levnadsvanor",
      "Kostnadsfritt första steg – du betalar först om du väljer att gå vidare till utredning.",
      "Din egen sjuksköterska och läkare",
      "Ingen bindningstid",
    ],
    additionalText:
      "Svara på några snabba frågor. En sjuksköterska går igenom dina svar och ger dig en kostnadsfri bedömning av om vi kan hjälpa dig.",
    ctaText: "Svara på frågorna",
    disclaimer:
      'En utredning genomförs innan vi påbörjar behandling för att säkerställa en korrekt diagnos. <a href="https://blodtrycksdoktorn.se/priser/" target="_blank">Se priser här</a>. Vi följer Läkemedelsverkets föreskrifter för medicinsk överviktsbehandling. Du legitimerar dig med BankID innan vi tar emot dina svar.',
  },
  RecommendationContent: ObesityRecommendationContent,
  steps: {
    ...obesitySteps,
    d2: disqualificationSteps.d2,
    d3: disqualificationSteps.d3,
    d5: disqualificationSteps.d5,
    l2: landingPageSteps.l2,
  },
  entryStepIds: ["q5", "l2"],
  formatAnswers: (base, state) => {
    if (state.height) {
      base.push({
        questionId: 125,
        answer: [Math.floor(state.height).toString()],
      });
    }
    if (state.weight) {
      base.push({
        questionId: 435,
        answer: [state.weight.toString()],
      });
    }
    return base;
  },
  useRecommendationABTest: (answers) => !!answers["q5"],
  appStoreUrls: {
    ios: IOS_OBESITY_STORE_PAGE_URL,
    android: ANDROID_OBESITY_STORE_PAGE_URL,
  },
  progressPath: ["q5", "o2", "q7", "o4", "o3"],
  alternativeProgressPath: ["q5", "q8", "q14", "q17"],
};
